<template>


      <div class="page-main">

        <LandingNavbar>
          <template #hero>
            <HomeHero />
          </template>
        </LandingNavbar>





        <!--app-content open-->
        <div class="main-content mt-0">
          <div class="side-app">

            <!-- CONTAINER -->
            <div class="main-container">
              <div class="">

                <!-- ROW-1 OPEN -->
                <div class="section pb-0">
                  <div class="container">
                    <div class="row">
                      <h4 class="text-center fw-semibold">La CNTIPPEE en chiffres</h4>
                      <span class="landing-title"></span>
                      <h2 class="text-center fw-semibold mb-7">
                        Un aperçu des projets, investissements et actions structurantes à l’échelle nationale.
                      </h2>
                    </div>

                    <div class="row text-center services-statistics landing-statistics">
                      <div
                          class="col-xl-3 col-md-6 col-lg-6"
                          v-for="(stat, index) in statistics"
                          :key="index"
                      >
                        <div class="card">
                          <div class="card-body bg-primary-transparent">
                            <div class="counter-status">
                              <div class="counter-icon bg-primary-transparent box-shadow-primary">
                                <i :class="stat.icon"></i>
                              </div>
                              <div class="test-body text-center">
                                <h1 class="mb-0">
                                  <span class="counter fw-semibold counter ">{{ stat.value }}</span>+
                                </h1>
                                <div class="counter-text">
                                  <h5 class="font-weight-normal mb-0 ">{{ stat.label }}</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <!-- ROW-1 CLOSED -->

                <!-- ROW-SERVICES OPEN -->
                <div class="sptb section bg-white" id="services">
                  <div class="container">
                    <div class="row text-center mb-7">
                      <h4 class="fw-semibold">Nos services</h4>
                      <span class="landing-title"></span>
                      <h2 class="fw-semibold">
                        Des services au service du développement et de l’investissement public
                      </h2>
                      <p class="text-default mt-3">
                        La CNTIPPEE accompagne l’État, les collectivités et les partenaires
                        dans la mise en œuvre, le suivi et l’évaluation de projets structurants.
                      </p>
                    </div>

                    <div class="row mt-5">

                      <!-- SERVICE 1 -->
                      <div class="col-lg-6 col-md-12">
                        <div
                            class="card features wow fadeInUp reveal revealleft"
                            data-wow-delay="0.1s"
                        >
                          <div class="d-flex align-items-start gap-3">
                            <i class="fe fe-layers fs-30 text-primary"></i>
                            <div>
                              <h4 class="fw-bold">Appui à la mise en œuvre des projets</h4>
                              <p class="mb-0">
                                Accompagnement technique et opérationnel pour la réalisation
                                de projets publics à fort impact économique et social.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>


                      <!-- SERVICE 2 -->
                      <div class="col-lg-6 col-md-12">
                        <div
                            class="card features wow fadeInUp reveal revealright"
                            data-wow-delay="0.1s"
                        >
                          <div class="d-flex align-items-start gap-3">
                            <i class="fe fe-briefcase fs-30 text-primary"></i>
                            <div>
                              <h4 class="fw-bold">Maîtrise d’ouvrage déléguée</h4>
                              <p class="mb-0">
                                Exécution des projets pour le compte des ministères,
                                collectivités territoriales et partenaires techniques et financiers.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>


                      <!-- SERVICE 3 -->
                      <div class="col-lg-6 col-md-12">
                        <div
                            class="card features wow fadeInUp reveal revealleft"
                            data-wow-delay="0.2s"
                        >
                          <div class="d-flex align-items-start gap-3">
                            <i class="fe fe-bar-chart-2 fs-30 text-primary"></i>
                            <div>
                              <h4 class="fw-bold">Suivi et évaluation des projets</h4>
                              <p class="mb-0">
                                Pilotage, suivi des indicateurs, contrôle de l’avancement
                                et évaluation des résultats des projets.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>


                      <!-- SERVICE 4 -->
                      <div class="col-lg-6 col-md-12">
                        <div
                            class="card features wow fadeInUp reveal revealright"
                            data-wow-delay="0.2s"
                        >
                          <div class="d-flex align-items-start gap-3">
                            <i class="fe fe-credit-card fs-30 text-primary"></i>
                            <div>
                              <h4 class="fw-bold">Gestion des financements</h4>
                              <p class="mb-0">
                                Gestion administrative et financière des projets financés
                                par l’État et les partenaires au développement.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>


                      <!-- SERVICE 5 -->
                      <div class="col-lg-6 col-md-12">
                        <div
                            class="card features wow fadeInUp reveal revealright"
                            data-wow-delay="0.2s"
                        >
                          <div class="d-flex align-items-start gap-3">
                            <i class="fe fe-credit-card fs-30 text-primary"></i>
                            <div>
                              <h4 class="fw-bold">Gestion des financements</h4>
                              <p class="mb-0">
                                Gestion administrative et financière des projets financés
                                par l’État et les partenaires au développement.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>


                      <!-- SERVICE 6 -->
                      <div class="col-lg-6 col-md-12">
                        <div class="card features wow fadeInUp">
                          <div class="d-flex align-items-start gap-3">
                            <i class="fe fe-globe fs-30 text-primary"></i>
                            <div>
                              <h4 class="fw-bold">Services numériques (E-Services)</h4>
                              <p class="mb-0">
                                Mise à disposition de services en ligne : demandes, réclamations,
                                rendez-vous, alertes et interactions avec les usagers.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <!-- ROW-SERVICES CLOSED -->


                <!-- ROW-ACTUALITES OPEN -->
                <div class="section bg-landing" id="actualites">
                  <div class="container">

                    <!-- TITRE -->
                    <div class="row text-center mb-7">
                      <h4 class="fw-semibold">Actualités</h4>
                      <span class="landing-title"></span>
                      <h2 class="fw-semibold">
                        Suivez les actions, projets et communications récentes de la CNTIPPEE
                      </h2>
                    </div>

                    <!-- CAROUSEL -->
                    <div
                        id="actualitesCarousel"
                        class="carousel slide"
                        data-bs-ride="carousel"
                        data-bs-interval="4000"
                    >
                      <div class="carousel-inner">

                        <div
                            class="carousel-item"
                            :class="{ active: index === 0 }"
                            v-for="(chunk, index) in newsChunks"
                            :key="index"
                        >
                          <div class="row">

                            <div
                                class="col-lg-4"
                                v-for="news in chunk"
                                :key="news.id"
                            >
                              <div class="card bg-transparent reveal">
                                <div class="card-body px-1">

                                  <!-- IMAGE -->
                                  <div
                                      class="news-image br-5 mb-3"
                                      :style="`background-image: url('${news.image}')`"
                                  ></div>

                                  <!-- CATÉGORIE -->
                                  <span class="badge bg-primary mb-2">
                    {{ news.category }}
                  </span>

                                  <!-- TITRE -->
                                  <h4 class="fw-bold">
                                    <router-link :to="`/actualites/${news.id}`">
                                      {{ news.title }}
                                    </router-link>
                                  </h4>

                                  <!-- RÉSUMÉ -->
                                  <p class="text-muted">
                                    {{ news.summary }}
                                  </p>

                                  <!-- META -->
                                  <div class="d-flex justify-content-between text-muted small mb-3">
                    <span>
                      <i class="fe fe-user me-1"></i>
                      {{ news.author }}
                    </span>
                                    <span>
                      <i class="fe fe-calendar me-1"></i>
                      {{ news.date }}
                    </span>
                                  </div>

                                  <!-- ACTION -->
                                  <router-link
                                      :to="`/actualites/${news.id}`"
                                      class="btn btn-outline-primary btn-sm"
                                  >
                                    Lire la suite
                                  </router-link>

                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                      </div>

                      <!-- CONTRÔLES -->
                      <button
                          class="carousel-control-prev"
                          type="button"
                          data-bs-target="#actualitesCarousel"
                          data-bs-slide="prev"
                      >
                        <span class="carousel-control-prev-icon"></span>
                      </button>

                      <button
                          class="carousel-control-next"
                          type="button"
                          data-bs-target="#actualitesCarousel"
                          data-bs-slide="next"
                      >
                        <span class="carousel-control-next-icon"></span>
                      </button>
                    </div>

                    <!-- LIEN VOIR TOUT -->
                    <div class="text-center mt-5">
                      <router-link
                          to="/actualites"
                          class="btn btn-outline-primary"
                      >
                        Voir toutes les actualités
                        <i class="fe fe-arrow-right ms-2"></i>
                      </router-link>
                    </div>

                  </div>
                </div>
                <!-- ROW-ACTUALITES CLOSED -->



                <!-- ROW-3 OPEN -->
                <div class="section bg-landing pb-0 bg-image-style" id="About">
                  <div class="container">
                    <div class="row">

                      <!-- TITRES -->
                      <h4 class="text-center fw-semibold">Qui sommes-nous ?</h4>
                      <span class="landing-title"></span>
                      <div class="text-center">
                        <h2 class="text-center fw-semibold">
                          Présentation de la Commission Nationale des TIPPEE
                        </h2>
                      </div>

                      <div class="col-lg-12">
                        <div class="card bg-transparent">
                          <div class="card-body text-dark">
                            <div class="statistics-info">
                              <div class="row">

                                <!-- IMAGE -->
                                <div class="col-xl-6 col-lg-6 ps-0">
                                  <div class="text-center reveal revealleft mb-3">
                                    <img
                                        src="/images/secretary/spcntippee.jpeg"
                                        alt="Secrétaire Permanente CNTIPPEE"
                                        class="br-5"
                                    >
                                  </div>
                                </div>

                                <!-- TEXTE -->
                                <div class="col-xl-6 col-lg-6 pe-0 my-auto">
                                  <div class="ps-5 reveal revealright">

                                    <h2 class="fw-semibold fs-25 mb-4">
                                      La Commission Nationale des Travaux d’Intérêt Public pour la Promotion
                                      de l’Entrepreneuriat et de l’Emploi (CN-TIPPEE)
                                    </h2>

                                    <p>
                                      Créée par décret <strong>N°000007/PR/MMPDD du 4 janvier 2006</strong>,
                                      la CN-TIPPEE est une entité permanente placée sous la tutelle
                                      du Ministère de l’Économie.
                                    </p>

                                    <p>
                                      Elle a pour mission d’apporter son appui à la réalisation de projets
                                      de développement au profit des ministères, des collectivités locales
                                      et de tout autre maître d’ouvrage public ou privé.
                                    </p>

                                    <!-- POINT 1 -->
                                    <div class="d-flex">
                      <span>
                        <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                          <path fill="#6c5ffc"
                                d="M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9L10,17Z" />
                        </svg>
                      </span>
                                      <div class="ms-5 mb-4">
                                        <h5 class="fw-bold">Agence d’exécution et de pilotage</h5>
                                        <p>
                                          La CN-TIPPEE assure les fonctions d’agence d’exécution,
                                          de maîtrise d’ouvrage déléguée et de maîtrise d’œuvre
                                          pour des projets structurants.
                                        </p>
                                      </div>
                                    </div>

                                    <!-- POINT 2 -->
                                    <div class="d-flex">
                      <span>
                        <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                          <path fill="#6c5ffc"
                                d="M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9L10,17Z" />
                        </svg>
                      </span>
                                      <div class="ms-5 mb-4">
                                        <h5 class="fw-bold">Gestion multisectorielle des projets</h5>
                                        <p>
                                          À travers son Secrétariat Permanent, la CN-TIPPEE gère
                                          simultanément plusieurs projets à fort impact économique
                                          et social sur l’ensemble du territoire national.
                                        </p>
                                      </div>
                                    </div>

                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <!-- ROW-3 CLOSED -->


                <!-- ROW-4 OPEN -->
                <div class="section testimonial-owl-landing">
                  <div class="container">
                    <div class="row">
                      <div class="card bg-transparent mb-0">
                        <h4 class="text-center fw-semibold text-white"> Liens utiles</h4>
                        <span class="landing-title"></span>
                        <div class="demo-screen-skin code-quality" id="dependencies">
                          <div class="text-center p-0">
                            <h2 class="text-center fw-semibold text-white mb-4">
                              Institutions, partenaires et plateformes officielles
                            </h2>

                            <p class="text-white-80 mb-5">
                              La CNTIPPEE collabore avec des institutions publiques, des partenaires
                              techniques et financiers pour la mise en œuvre et le suivi des projets
                              d’investissements publics à fort impact.
                            </p>
                            <div class="row justify-content-center">
                              <div class="col-lg-12 px-0">
                                <div class="feature-logos mt-5">
                                  <div class="slide">
                                    <a
                                        href="https://www.presidence.ga"
                                        target="_blank"
                                        class="slide text-center text-decoration-none"
                                    >
                                      <img src="/images/partners/aninf.jpeg" alt="Présidence Gabonaise">
                                      <h5 class="mt-3 text-white">Présidence</h5>
                                    </a>
                                  </div>
                                  <div class="slide">
                                    <a
                                        href="https://www.primature.ga"
                                        target="_blank"
                                        class="slide text-center text-decoration-none"
                                    >
                                      <img src="/assets/images/landing/3.png" alt="Primature">
                                      <h5 class="mt-3 text-white">Primature</h5>
                                    </a>
                                  </div>
                                  <div class="slide">
                                    <a
                                        href="https://www.economie.gouv.ga"
                                        target="_blank"
                                        class="slide text-center text-decoration-none"
                                    >
                                      <img src="/images/partners/arcep.jpeg" alt="Ministère de l'Économie">
                                      <h5 class="mt-3 text-white">Ministère de l’Économie</h5>
                                    </a>
                                  </div>
                                  <div class="slide">
                                    <a
                                        href="https://www.banquemondiale.org"
                                        target="_blank"
                                        class="slide text-center text-decoration-none"
                                    >
                                      <img src="/images/partners/cnee.jpeg" alt="Banque Mondiale">
                                      <h5 class="mt-3 text-white">Banque mondiale</h5>
                                    </a>
                                  </div>
                                  <div class="slide">
                                    <a
                                        href="https://www.afdb.org"
                                        target="_blank"
                                        class="slide text-center text-decoration-none"
                                    >
                                      <img src="/images/partners/cnpdcp.jpeg" alt="BAD">
                                      <h5 class="mt-3 text-white">BAD</h5>
                                    </a>
                                  </div>
                                  <div class="slide">
                                    <a
                                        href="https://www.undp.org"
                                        target="_blank"
                                        class="slide text-center text-decoration-none"
                                    >
                                      <img src="/images/partners/sing.jpeg" alt="PNUD">
                                      <h5 class="mt-3 text-white">PNUD</h5>
                                    </a>
                                  </div>
                                  <div class="slide">
                                    <a
                                        href="https://www.undp.org"
                                        target="_blank"
                                        class="slide text-center text-decoration-none"
                                    >
                                      <img src="/images/partners/arcep.jpeg" alt="PNUD">
                                      <h5 class="mt-3 text-white">PNUD</h5>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- ROW-4 CLOSED -->


                <!-- ROW-CTA OPEN -->
                <div class="section cta-bg-section">
                  <div class="cta-overlay"></div>

                  <div class="container">
                    <div class="row justify-content-center">

                      <!-- NEWSLETTER -->
                      <div class="col-lg-5 col-md-12 mb-4">
                        <div class="cta-card cta-blue reveal revealleft">
                          <div class="cta-icon">
                            <i class="fe fe-mail"></i>
                          </div>

                          <h3 class="fw-bold mb-2">Abonnez-vous à notre newsletter</h3>
                          <p class="text-muted mb-4">
                            Soyez les premiers à être informés de nos dernières actualités
                          </p>

                          <div class="input-group">
                            <input
                                type="email"
                                class="form-control"
                                placeholder="Votre email"
                            />
                            <button class="btn btn-dark">
                              S’inscrire
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- SUGGESTION / PLAINTE -->
                      <div class="col-lg-5 col-md-12 mb-4">
                        <div class="cta-card cta-orange reveal revealright">
                          <div class="cta-icon">
                            <i class="fe fe-message-square"></i>
                          </div>

                          <h3 class="fw-bold mb-2">Une plainte ou une suggestion ?</h3>
                          <p class="text-muted mb-4">
                            Merci de nous aider à mieux vous servir
                          </p>

                          <div class="input-group">
                            <select class="form-select">
                              <option selected disabled>De quoi s’agit-il ?</option>
                              <option>Suggestion</option>
                              <option>Plainte</option>
                              <option>Demande d’information</option>
                            </select>
                            <button class="btn btn-dark">
                              Continuer
                            </button>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <!-- ROW-CTA CLOSED -->

                <!-- SECTION LIENS UTILES OPEN -->
                <div class="section bg-primary-dark py-6" id="liens-utiles">
                  <div class="container">

                    <!-- TITRE -->
                    <div class="row text-center mb-5">
                      <h2 class="fw-semibold text-white">Liens utiles</h2>
                      <p class="text-white-80">
                        Accès rapide aux plateformes et ressources institutionnelles
                      </p>
                    </div>

                    <!-- CARTES -->
                    <div class="row justify-content-center g-4">

                      <!-- MARCHÉS PUBLICS -->
                      <div class="col-lg-3 col-md-6">
                        <a href="#" class="useful-link-card">
                          <div class="icon-circle">
                            <i class="fe fe-briefcase"></i>
                          </div>
                          <span>Marchés publics</span>
                        </a>
                      </div>

                      <!-- DOCUMENTATIONS -->
                      <div class="col-lg-3 col-md-6">
                        <a href="#" class="useful-link-card">
                          <div class="icon-circle">
                            <i class="fe fe-book-open"></i>
                          </div>
                          <span>Documentations</span>
                        </a>
                      </div>

                      <!-- RAPPORT PEFA -->
                      <div class="col-lg-3 col-md-6">
                        <a href="#" class="useful-link-card">
                          <div class="icon-circle">
                            <i class="fe fe-file-text"></i>
                          </div>
                          <span>Rapport PEFA</span>
                        </a>
                      </div>

                      <!-- PROGRAMME PC2D -->
                      <div class="col-lg-3 col-md-6">
                        <a href="#" class="useful-link-card">
                          <div class="icon-circle">
                            <i class="fe fe-layers"></i>
                          </div>
                          <span>Programme PC2D</span>
                        </a>
                      </div>

                    </div>

                  </div>
                </div>
                <!-- SECTION LIENS UTILES CLOSED -->

                <!-- ROW-7 OPEN -->
                <div class="section" id="Faqs">
                  <div class="container">
                    <div class="row">
                      <h4 class="text-center fw-semibold">FAQ'S ?</h4>
                      <span class="landing-title"></span>
                      <h2 class="text-center fw-semibold">Nous sommes là pour vous aider</h2>
                      <div class="row justify-content-center">
                        <p class="col-xl-9 wow fadeInUp text-default sub-text mb-7"
                           data-wow-delay="0s">
                          Retrouvez ici les réponses aux questions les plus fréquentes sur les offres de marchés,
                          l’attribution, l’exécution des projets, le suivi, les paiements et la transparence.
                        </p>
                      </div>
                      <section class="sptb demo-screen-demo" id="faqs1">
                        <div class="row align-items-center">
                          <div class="col-md-12 col-lg-6">
                            <div class="col-md-12 grid-item  px-0">
                              <div
                                  class="card card-collapsed bg-primary-transparent p-0 reveal">
                                <div class="card-header grid-link"
                                     data-bs-toggle="card-collapse">
                                  <a href="#"
                                     class="card-options-collapse h5 fw-bold card-title mb-0"><span
                                      class="me-3 fs-18 fw-bold text-primary">01.</span>Comment consulter les offres de marchés disponibles ?</a>
                                </div>
                                <div class="card-body pt-0">
                                  <p>
                                    Les offres sont publiées dans la rubrique <b>Offres de marchés</b>. Vous pouvez filtrer
                                    par secteur, région, date de publication ou statut (ouvert / clôturé).
                                  </p>
                                  <p class="mt-2 mb-3">
                                    <span class="fw-bold">Note: </span>Activez les alertes pour être notifié des nouvelles publications.
                                  </p>
                                  <a href="javascript:void(0)"
                                     class="btn btn-outline-primary tx-13">Voir les offres</a>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 grid-item  px-0">
                              <div
                                  class="card card-collapsed bg-success-transparent p-0 reveal">
                                <div class="card-header grid-link"
                                     data-bs-toggle="card-collapse">
                                  <a href="#"
                                     class="card-options-collapse  h5 fw-bold card-title mb-0"><span
                                      class="me-3 fs-18 fw-bold text-success">02.</span>Comment soumettre une offre et quels documents fournir ?</a>
                                </div>
                                <div class="card-body pt-0">
                                  <p>
                                    Créez votre compte, complétez votre profil entreprise, puis déposez votre dossier en ligne
                                    (pièces administratives, offre technique et offre financière selon le DAO).
                                  </p>
                                  <p class="mt-2 mb-3">
                                    <span class="fw-bold">Note: </span>Respectez la date limite et le format demandé (PDF, Excel, etc.).
                                  </p>
                                  <a href="javascript:void(0)"
                                     class="btn btn-outline-success tx-13">Guide de soumission</a>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 grid-item  px-0">
                              <div
                                  class="card card-collapsed bg-secondary-transparent p-0 reveal">
                                <div class="card-header grid-link"
                                     data-bs-toggle="card-collapse">
                                  <a href="#"
                                     class="card-options-collapse  h5 fw-bold card-title mb-0"><span
                                      class="me-3 fs-18 fw-bold text-secondary">03.</span>Comment se fait l’attribution d’un marché ?</a>
                                </div>
                                <div class="card-body pt-0">
                                  <p>
                                    L’attribution suit une procédure formelle : ouverture, analyse, évaluation, validation
                                    puis publication des résultats selon les critères définis dans le dossier d’appel d’offres.
                                  </p>
                                  <p class="mt-2 mb-3">
                                    <span class="fw-bold">Note: </span>Les décisions sont tracées pour garantir transparence et conformité.
                                  </p>
                                  <a href="javascript:void(0)"
                                     class="btn btn-outline-secondary tx-13">Comprendre la procédure</a>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 grid-item  px-0">
                              <div
                                  class="card card-collapsed bg-warning-transparent p-0 reveal">
                                <div class="card-header grid-link"
                                     data-bs-toggle="card-collapse">
                                  <a href="#"
                                     class="card-options-collapse  h5 fw-bold card-title mb-0"><span
                                      class="me-3 fs-18 fw-bold text-warning">04.</span>Comment suivre l’exécution d’un projet après attribution ?</a>
                                </div>
                                <div class="card-body pt-0">
                                  <p>
                                    Un tableau de suivi permet de visualiser l’avancement : planning, livrables, PV,
                                    indicateurs, délais, et jalons de validation.
                                  </p>
                                  <p class="mt-2 mb-3">
                                    <span class="fw-bold">Note: </span>Les mises à jour sont effectuées selon les étapes prévues au contrat.
                                  </p>
                                  <a href="javascript:void(0)"
                                     class="btn btn-outline-warning tx-13">Voir le suivi</a>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 grid-item  px-0">
                              <div
                                  class="card card-collapsed bg-danger-transparent p-0 reveal">
                                <div class="card-header grid-link"
                                     data-bs-toggle="card-collapse">
                                  <a href="#"
                                     class="card-options-collapse  h5 fw-bold card-title mb-0"><span
                                      class="me-3 fs-18 fw-bold text-danger">05.</span>Comment sont gérés les paiements et les décomptes ?</a>
                                </div>
                                <div class="card-body pt-0">
                                  <p>
                                    Les paiements se font sur la base des livrables validés (PV de réception, attachements,
                                    décomptes). Chaque étape est enregistrée et consultable.
                                  </p>
                                  <p class="mt-2 mb-3">
                                    <span class="fw-bold">Note: </span>En cas de retard, une justification et des actions correctives peuvent être exigées.
                                  </p>
                                  <a href="javascript:void(0)"
                                     class="btn btn-outline-danger tx-13">Informations paiement</a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12 col-lg-6 reveal revealright">
                            <img src="/assets/images/landing/2.png"
                                 alt="">
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
                <!-- ROW-7 CLOSED -->



                <!-- ROW-9 OPEN -->
                <div class="testimonial-owl-landing section pb-0" id="projects">
                  <div class="container">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="card bg-transparent">
                          <div class="card-body pt-5">

                            <!-- TITRES -->
                            <h4 class="text-center fw-semibold text-white-80">
                              Nos projets
                            </h4>
                            <span class="landing-title"></span>
                            <h2 class="text-center fw-semibold text-white mb-7">
                              Quelques projets déjà réalisés à travers le Gabon
                            </h2>

                            <!-- CAROUSEL -->
                            <div class="testimonial-carousel">

                              <!-- PROJET 1 -->
                              <div class="slide text-center">
                                <div class="row">
                                  <div class="col-xl-8 col-md-12 d-block mx-auto">
                                    <div class="testimonia">
                                      <p class="text-white-80">
                                        <i class="fa fa-quote-left fs-20 text-white-80"></i>
                                        Construction et réhabilitation d’infrastructures communautaires
                                        visant à améliorer l’accès aux services sociaux de base
                                        dans plusieurs localités du Grand Libreville.
                                      </p>
                                      <h3 class="title">
                                        Projet d’infrastructures communautaires
                                      </h3>
                                      <span class="post">
                        Libreville – Estuaire
                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- PROJET 2 -->
                              <div class="slide text-center">
                                <div class="row">
                                  <div class="col-xl-8 col-md-12 d-block mx-auto">
                                    <div class="testimonia">
                                      <p class="text-white-80">
                                        <i class="fa fa-quote-left fs-20"></i>
                                        Programme de promotion de l’emploi des jeunes à travers
                                        des travaux à haute intensité de main-d’œuvre (HIMO),
                                        contribuant à l’insertion professionnelle durable.
                                      </p>
                                      <h3 class="title">
                                        Programme HIMO Jeunes
                                      </h3>
                                      <span class="post">
                        Provinces de l’Ogooué-Maritime et du Moyen-Ogooué
                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- PROJET 3 -->
                              <div class="slide text-center">
                                <div class="row">
                                  <div class="col-xl-8 col-md-12 d-block mx-auto">
                                    <div class="testimonia">
                                      <p class="text-white-80">
                                        <i class="fa fa-quote-left fs-20"></i>
                                        Aménagement et entretien de voiries urbaines,
                                        contribuant à l’amélioration de la mobilité,
                                        de la sécurité et du cadre de vie des populations.
                                      </p>
                                      <h3 class="title">
                                        Projet de voiries urbaines
                                      </h3>
                                      <span class="post">
                        Franceville – Haut-Ogooué
                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                            <!-- /CAROUSEL -->

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- ROW-9 CLOSED -->



                <!-- ROW-11 OPEN -->
                <div class="">
                  <div class="container">
                    <div class="testimonial-owl-landing buynow-landing reveal revealrotate">
                      <div class="row pt-6">
                        <div class="col-md-12">
                          <div class="card bg-transparent">
                            <div class="card-body px-7 py-5">

                              <div class="row text-white align-items-center text-center text-lg-start">

                                <!-- TÉLÉPHONE -->
                                <div class="col-lg-3 mb-4 mb-lg-0 d-flex align-items-center justify-content-center justify-content-lg-start">
                                  <i class="fe fe-phone fs-30 me-3"></i>
                                  <div>
                                    <div class="fw-semibold">Téléphone</div>
                                    <div class="text-white-80">+241 11 73 19 63</div>
                                  </div>
                                </div>

                                <!-- EMAIL / SITE -->
                                <div class="col-lg-3 mb-4 mb-lg-0 d-flex align-items-center justify-content-center">
                                  <i class="fe fe-mail fs-30 me-3"></i>
                                  <div>
                                    <div class="fw-semibold">Contact</div>
                                    <div class="text-white-80">contact@cntippee-gabon.org</div>
                                    <div class="text-white-80">www.cntippee-gabon.org</div>
                                  </div>
                                </div>

                                <!-- ADRESSE -->
                                <div class="col-lg-3 mb-4 mb-lg-0 d-flex align-items-center justify-content-center">
                                  <i class="fe fe-map-pin fs-30 me-3"></i>
                                  <div>
                                    <div class="fw-semibold">Adresse</div>
                                    <div class="text-white-80">
                                      Haut de Gué-Gué, 117 Impasse<br>
                                      André MBA OBAME<br>
                                      BP 22, Libreville
                                    </div>
                                  </div>
                                </div>

                                <!-- BOUTON ACTION -->
                                <div class="col-lg-3 text-center text-lg-end">
                                  <router-link
                                      to="/contact"
                                      class="btn btn-lg btn-primary-gradient"
                                  >
                                    <i class="fe fe-send me-2"></i>
                                    Nous contacter
                                  </router-link>
                                </div>

                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- ROW-11 CLOSED -->



              </div>
            </div>
            <!-- CONTAINER CLOSED-->
          </div>
        </div>
      </div>
</template>

<script>




  import LandingFooter from "../../components/landing/LandingFooter.vue";
  import LandingHeader from "../../components/landing/LandingHeader.vue";
  import LandingNavbar from "../../components/landing/LandingNavbar.vue";
  import {projectsMock} from "../../mocks/projects.mock";
  import {statisticsMock} from "../../mocks/statistics.mock";
  import {newsMock} from "../../mocks/news.mock";
  import HomeHero from "../../components/landing/HomeHero.vue";

  export default {
    name: 'PublicHome',
    components: {HomeHero, LandingNavbar, LandingHeader, LandingFooter},
    data() {
      return {
        statistics: [],
        featuredProjects: [],
        latestNews: []
      }
    },
    beforeDestroy() {
      // Optionnel : nettoyer les scripts spécifiques si nécessaire
      document.querySelector('script[src*="landing.js"]')?.remove();
    },
    async mounted() {
      // On attend que Vue ait fini le rendu HTML
      await this.$nextTick();

      // On lance le chargement ordonné
      await this.initLandingScripts();
      this.statistics = statisticsMock
      this.featuredProjects = projectsMock.slice(0, 3)
      this.latestNews = newsMock
    },
    computed: {
      newsChunks() {
        const size = 3
        const chunks = []

        for (let i = 0; i < this.latestNews.length; i += size) {
          chunks.push(this.latestNews.slice(i, i + size))
        }

        return chunks
      }
    },
    methods: {
      loadScript(src) {
        return new Promise((resolve, reject) => {
          // Vérifie si le script existe déjà
          if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
          }

          const s = document.createElement('script');
          s.src = src;
          s.async = false; // Important : garde l'ordre d'exécution si le navigateur le gère mal
          s.onload = resolve;
          s.onerror = reject;
          document.body.appendChild(s);
        });
      },

      async initLandingScripts() {
        try {
          console.log("Chargement des scripts Landing...");

          // 1. Groupe Compteurs (Dépendances d'abord !)
          // waypoints est requis par counterup
          await this.loadScript('/assets/plugins/counters/waypoints.min.js');
          await this.loadScript('/assets/plugins/counters/counterup.min.js');
          // counters-1 lance l'animation, donc en dernier
          await this.loadScript('/assets/plugins/counters/counters-1.js');

          // 2. Groupe Carousel
          await this.loadScript('/assets/plugins/owl-carousel/owl.carousel.js');
          await this.loadScript('/assets/plugins/company-slider/slider.js');

          // 3. Groupe Ratings (Notes)
          await this.loadScript('/assets/plugins/rating/jquery-rate-picker.js');
          await this.loadScript('/assets/plugins/rating/rating-picker.js');

          await this.loadScript('/assets/plugins/ratings-2/jquery.star-rating.js');
          await this.loadScript('/assets/plugins/ratings-2/star-rating.js');

          // 4. Scripts UI Globaux (Sticky & Main Landing)
          // Sticky doit souvent être là avant landing.js
          await this.loadScript('/assets/js/sticky.js');
          await this.loadScript('/assets/js/landing.js');

          console.log("Tous les scripts Landing sont chargés.");

          // Petit hack : parfois le sticky header a besoin d'un scroll event pour se réveiller
          window.dispatchEvent(new Event('scroll'));

        } catch (err) {
          console.error("Erreur lors du chargement des scripts Landing :", err);
        }
      }
    },
  }

</script>

<style>
.hor-header {
  position: sticky;
  top: 0;
  z-index: 1050;
  background: #fff;
}

.page-main {
  overflow: visible !important;
}

.news-image {
  width: 100%;
  height: 220px;              /* hauteur uniforme */
  background-size: cover;     /* clé du problème */
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
}

/* SECTION BACKGROUND */
.cta-bg-section {
  position: relative;
  padding: 100px 0;
  background-image: url('/assets/images/landing/cta-bg.jpg'); /* ⚠️ change l’image ici */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* Overlay sombre */
.cta-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 0;
}

/* CARTES */
.cta-card {
  position: relative;
  z-index: 1;
  background: #fff;
  padding: 40px;
  border-radius: 14px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

/* Variantes couleur */
.cta-blue::before,
.cta-orange::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 90px;
  height: 90px;
  clip-path: polygon(100% 0, 0 0, 100% 100%);
}

.cta-blue::before {
  background: #3b82f6;
}

.cta-orange::before {
  background: #f59e0b;
}

/* Icône */
.cta-icon {
  font-size: 32px;
  margin-bottom: 20px;
  color: #fff;
}

.cta-blue .cta-icon {
  color: #3b82f6;
}

.cta-orange .cta-icon {
  color: #f59e0b;
}

/* Responsive */
@media (max-width: 768px) {
  .cta-bg-section {
    padding: 70px 0;
  }
}

.buynow-landing .col-lg-4:not(:last-child) {
  border-right: 1px solid rgba(255,255,255,0.2);
}


.bg-primary-dark {
  background-color: #0b3a66; /* bleu institutionnel */
}

.useful-link-card {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 18px 22px;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 10px;
  color: #fff;
  text-decoration: none;
  transition: all 0.3s ease;
}

.useful-link-card:hover {
  background: rgba(255,255,255,0.1);
  transform: translateY(-3px);
}

.useful-link-card span {
  font-weight: 500;
  font-size: 16px;
}

.icon-circle {
  width: 48px;
  height: 48px;
  background: #3b82f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-circle i {
  font-size: 20px;
  color: #fff;
}

.text-white-80 {
  color: rgba(255,255,255,0.8);
}


</style>
